module.exports = __webpack_public_path__ + "img/main_bg_02.14deb2c4.png";